import Sidebar from "../components/Sidebar";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ImageDisplay from "../components/ImageDisplayOther";
import UploadButton from "../components/UploadButton";
import RadioInput from "../components/RadioInput";
import InferenceButton from "../components/InferenceButton";
import CrackDetectedModal from "../components/CrackDetectedModal";
import CrackNotDetectedModal from "../components/CrackNotDetectedModal";
import Header from "../components/Header-vgg16";

const Vgg16 = () => {
  // HOOKS
  const [detectionOccurred, setDetectionOccurred] = useState(false); // To disable the inference button while infering
  const [upload, setUpload] = useState(null); // Store the uploaded image in a hook
  const [imgData, setimgData] = useState(null); // Store the bbox data in a hook
  const [base64Image, setBase64Image] = useState(null); // Store the base64 image in a hook
  const [isCrackNotDetectedModalOpen, setCrackNotDetectedModalOpen] =
    useState(null); // New state for modal visibility
  const [isCrackDetectedModalOpen, setCrackDetectedModalOpen] = useState(false); // New state for modal visibility
  const [outputOption, setOutputOption] = useState("image"); // FOR RADIO BTN VALUE
  const [isInfering, setIsInfering] = useState(false); // To disable the inference button while infering

  // Function to handle detection
  const handleDetection = (value) => {
    setDetectionOccurred(value);
  };

  // Function to open/close the modal
  const handleCrackDetectedModalToggle = () => {
    setCrackDetectedModalOpen(!isCrackDetectedModalOpen);
  };

  // useEffect to open the modal when detection occurs
  useEffect(() => {
    if (detectionOccurred) {
      setCrackDetectedModalOpen(true);
    }
  }, [detectionOccurred]);

  // Function to open/close the modal
  const handleCrackNotDetectedModalToggle = () => {
    setCrackNotDetectedModalOpen(!isCrackNotDetectedModalOpen);
  };

  // useEffect to open the modal when detection occurs
  useEffect(() => {
    // Only open CrackNotDetectedModal if detectionOccurred is false and isInfering is true
    if (detectionOccurred === false && isInfering) {
      setCrackNotDetectedModalOpen(true);
    }
  }, [detectionOccurred, isInfering]);

  // FOR RADIO BTN VALUE
  const handleRadioChange = (value) => {
    setOutputOption(value);
  };

  console.log("Current radio button value:", outputOption);

  const location = useLocation();

  // Function to handle file change and convert the image to base64
  const handleFileChange = (event) => {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      setUpload(file);
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const base64String = e.target.result;
          setBase64Image(base64String);
        };

        reader.readAsDataURL(file);
      }
    }
  };

  // Function to send the image to the API
  const sendImageToAPI = async () => {
    const url =
      "[redacted]";

    try {
      const formData = new FormData();
      formData.append("file", upload);

      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      setIsInfering(true);
      const data = await response.json();
      setimgData(data);
      const str = JSON.stringify(data);
      console.log(str);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  // Function to render the modal depending on the detection result
  const renderModal = () => {
    if (detectionOccurred) {
      return (
        <CrackDetectedModal
          isOpen={isCrackDetectedModalOpen}
          onClose={handleCrackDetectedModalToggle}
        />
      );
    } else if (isCrackNotDetectedModalOpen) {
      return (
        <CrackNotDetectedModal
          isOpen={isCrackNotDetectedModalOpen}
          onClose={handleCrackNotDetectedModalToggle}
        />
      );
    } else {
      return null;
    }
  };

  // Read the theme from local storage on component mount
  const savedTheme = localStorage.getItem("theme");
  const [theme, setTheme] = React.useState(savedTheme || "light");

  // On mount or theme change, update the local storage
  useEffect(() => {
    localStorage.setItem("theme", theme);

    // Update the class based on the theme
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    console.log("Theme is: ", theme);
  }, [theme]);

  // To toggle between dark and light mode
  const handleThemeChange = () => {
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  };

  return (
    <div className="flex flex-col w-full h-full bg-customBackground dark:bg-customLightBackground overflow-x-hidden">
      <Sidebar activePage={location.pathname} />
      <Header onThemeChange={handleThemeChange} theme={theme}>VGG16 Model</Header>

      <div className="flex flex-col lg:flex-row justify-center lg:space-x-[100px] items-center z-10 mx-6">
        <div className="order-1 mb-[48px]">
          <UploadButton onChange={handleFileChange} theme={theme}/>
        </div>

        <div className="order-2 mb-[48px]">
          <RadioInput
            selectedValue={outputOption}
            onRadioChange={handleRadioChange}
            theme={theme}
          />
        </div>

        <div className="order-4  mb-[48px]">
          <InferenceButton onClick={sendImageToAPI} theme={theme}/>
        </div>

        <div className="order-3 lg:hidden mb-8">
          <div className="flex w-screen h-fit mb-2 overflow-x-hidden z-0">
            <ImageDisplay
              selectedImage={base64Image}
              imgData={imgData}
              radioBtnValue={outputOption}
              onDetection={handleDetection}
            />
          </div>
        </div>
      </div>

      <div className="hidden lg:flex w-screen h-fit mb-2 overflow-x-hidden z-0 px-4">
        <ImageDisplay
          selectedImage={base64Image}
          imgData={imgData}
          radioBtnValue={outputOption}
          onDetection={handleDetection}
        />
      </div>

      {renderModal()}
    </div>
  );
};

export default Vgg16;
